// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function TogglesGroup(props) {
  let __inline = props.inline;
  let inline = __inline !== undefined ? __inline : false;
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "flex items-start flex-col space-y-2.5",
      inline ? "md:flex-row md:space-y-0 md:space-x-6" : ""
    ])
  });
}

let make = TogglesGroup;

exports.make = make;
/* tailwind-merge Not a pure module */
